import axios from 'axios';

export const installIntegration = async (payload) => {
    const response = await axios.post('/app/funnelIntegrationDevTool/installAutomationIntegration', payload, {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
        },
    });

    return response.data;
};

export const uninstallIntegration = async (payload) => {
    const response = await axios.post('/app/funnelIntegrationDevTool/uninstallAutomationIntegration', payload, {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'Response-Type': 'text',
        },
    });

    return response.data;
};

export const createTrigger = async (payload) => {
    const response = await axios.post('/app/funnelIntegrationDevTool/createAutomationIntegrationTrigger', payload, {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
        },
    });

    return response.data;
};
